/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_PlaybackInputs */



/**
* | output |
* | --- |
* | "Local and Cloud File Playback" |
*
* @param {Signup_Compare_PlaybackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_playback = /** @type {((inputs?: Signup_Compare_PlaybackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_PlaybackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Local and Cloud File Playback")
	if (locale === "de") return /** @type {LocalizedString} */ ("Local and Cloud File Playback")
	if (locale === "it") return /** @type {LocalizedString} */ ("Local and Cloud File Playback")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Local and Cloud File Playback")
	if (locale === "es") return /** @type {LocalizedString} */ ("Local and Cloud File Playback")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Local and Cloud File Playback")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Local and Cloud File Playback")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Local and Cloud File Playback")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Local and Cloud File Playback")
	return /** @type {LocalizedString} */ ("Local and Cloud File Playback")
});